/* src/app/invoice/management/invoice-management-container/invoice-management-container.component.scss */
body#themeTag :host ::ng-deep .ef-checkbox label {
  padding-right: 1rem;
}
body#themeTag :host ::ng-deep .ef-checkbox label:not(.p-dropdown-label) {
  font-weight: normal !important;
  font-size: 12px !important;
}
body#themeTag :host ::ng-deep .ef-checkbox label.p-dropdown-label {
  font-weight: normal;
}
body#themeTag :host .filters {
  padding: 0;
  padding-bottom: 0.5em;
  height: 38px;
}
body#themeTag :host .invoice-cycle,
body#themeTag :host .invoice-management,
body#themeTag :host .invoice-charge-number {
  height: calc(100% - 38px);
}
/*# sourceMappingURL=invoice-management-container.component.css.map */
